import React, { useMemo, useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import SendMessageModal from "./SendMessageModal";
import { features } from "../../config/features";

export default function MessageUserButton({ user }) {
    const { user: me, isAuthenticated } = useAuth();
    const [open, setOpen] = useState(false);

    const canShow = useMemo(() => {
        if (!isAuthenticated || !user?.id) {
            return false;
        }
        if (!features.messaging) {
            return false;
        }
        if (me?.id === user.id) {
            return false;
        }
        return Boolean(user.allowPrivateMessages);
    }, [isAuthenticated, me?.id, user]);

    if (!canShow) {
        return null;
    }

    return (
        <>
            <button type="button" className="ghost-btn" onClick={() => setOpen(true)} title="Написать сообщение">
                💬
            </button>
            {open && <SendMessageModal targetUser={user} onClose={() => setOpen(false)} />}
        </>
    );
}
